import React, { useState, useEffect } from 'react';
import {IconButton, Box, Button, Dialog, DialogTitle, DialogActions, DialogContent, Typography, TextField, Stack, InputAdornment, InputLabel, FormControl, OutlinedInput, FormHelperText, Link } from '@mui/material';
import ImageUpload from './imageUpload';
import { addUser } from '../services/user.js';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeUserAction } from '../actions/profile.js';


const PortfolioRow = ({title, link, setTitle, setLink, deletePortfolio, editable, setEditable}) => {
    const [localTitle, setLocalTitle] = useState('')
    const [localLink, setLocalLink] = useState('');
    const [error, setError] = useState(false)
    useEffect(()=>{
        if (link) {
            setLocalLink(link)
        }
        if (title) {
            setLocalTitle(title)
        }
    }, [link, title])
    const isValidUrl = (url) => /^(https?:\/\/)/i.test(url.trim());
    const handleApply = () =>{
         const validUrl = isValidUrl(localLink)
         if (localLink.trim() && localTitle.trim()&& validUrl) {
            setLink(localLink);
            setTitle(localTitle);
            setEditable(false);
         } else {
            setError(true)
         }
    }
    const handleCancel = ()=>{
        if (localLink.trim() && localTitle.trim()) {
            setEditable(false)
        } if (!link || !title) {
            deletePortfolio()
        }
    }
    const handleKeyDown = (event) =>{
        if (event.key === 'Enter') {
            event.preventDefault();
            handleApply(); // Your custom function
            return;
          }
    }
    if (editable) {
        return (
            <Stack direction="row" sx={{mb:2}} justifyContent="space-between">
                <TextField
                    label="Title"
                    value={localTitle}
                    sx={{width: '40%', mr: 2}}
                    onChange={(e)=> setLocalTitle(e.target.value)}
                    variant="outlined"
                 />
                <TextField
                    label="Link"
                    value={localLink}
                    sx={{width: '40%'}}
                    onChange={(e)=> setLocalLink(e.target.value)}
                    variant="outlined"
                    error={error}
                    onKeyDown={handleKeyDown}
                    helperText={error && "Invalid URL"}
                />
                <IconButton aria-label="apply" onClick={handleApply}><CheckIcon/></IconButton>
                <IconButton aria-label="cancel" onClick={handleCancel}><CloseIcon/></IconButton>
                <IconButton aria-label="delete" onClick={deletePortfolio}><DeleteIcon/></IconButton>
            </Stack>
        )
    } else {
        return (<Stack direction="row" alignItems="center">
            <Link href={link} target="_blank" rel="noreferrer">
                <Typography>{title}</Typography>
            </Link>
            <IconButton sx={{ml:2}} onClick={()=>{setEditable(true) }} aria-label="delete">
                <EditIcon/>
            </IconButton>
        </Stack>)
    }

}

const PortfolioSection = ({portfolios, initPortfolio, deletePortfolio,setEditable, setPortfolio }) => {
    return (
        <Stack sx={{width: '100%'}}>
            <Typography sx={{fontWeight: 'bold'}}>Portfolio</Typography>
            {portfolios.map((portfolio, index) => <PortfolioRow
                                                        key={`porfolio-${index}`}
                                                        title={portfolio.title}
                                                        editable={portfolio.editable}
                                                        setEditable={setEditable(index)}
                                                        link={portfolio.link}
                                                        deletePortfolio={deletePortfolio(index)}
                                                        setTitle={setPortfolio(index, 'title')}
                                                        setLink={setPortfolio(index, 'link')}
                                                    />
                                                )}
            {portfolios.length === 0 && <Box sx={{width: '100%', display:'flex', flexDirection: 'row', justifyContent:'flex-end'}}><Button sx={{width: 200}} variant="contained" onClick={initPortfolio}>Add Portfolio</Button></Box>}
            {portfolios.length > 0 && portfolios.length < 5 && <Box sx={{width: '100%', display:'flex', flexDirection: 'row', justifyContent:'flex-end'}}><Button onClick={initPortfolio} variant="contained">Add More</Button></Box>}
        </Stack>

    )
}

const AddUser = (props) => {
    const [name, setName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [address, setAddress] = React.useState('');
    const [akpano, setAkpano] = React.useState('');    
    const [file, setFile] = React.useState(undefined);    
    const [avatarUrl, setAvatarUrl] = React.useState('');
    const [proofUrl, setProofUrl] = React.useState('');
    const [proofBackUrl, setProofBackUrl] = React.useState('');
    const [proofFile, setProofFile] = React.useState(undefined);
    const [proofBackFile, setProofBackFile] = React.useState(undefined);
    const [refName, setRefName] = useState();
    const [refPhone, setRefPhone] = useState();
    const [notes, setNotes] = useState();
    const [cropOpen, setCropOpen] = useState(false)
    const [portfolios, setPortfolios] = useState([])
    
    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState({});

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const setPortfolio = (index, attr) => {
        return (val) => {
            console.log(index, attr, val)
            const _portfolios = [...portfolios]
            _portfolios[index][attr] = val;
            setPortfolios(_portfolios)
        }
    }
    const deletePortfolio = (index) => {
        return () => {
            const _portfolios = [...portfolios]
            _portfolios.splice(index, 1)
            setPortfolios(_portfolios)
        }
    }
    
    const setEditable = (index) => {
        return (val) => {
            console.log(val, index)
            const _portfolios = [...portfolios]
            _portfolios[index].editable = val;
            setPortfolios(_portfolios)
        }
    }

    const initPortfolio = (e) =>{
        setPortfolios([...portfolios, {
            title:"",
            link:"",
            editable: true,
        }])
    }
    const handleAddUserClose = (e) => {
        setName()
        setLastName()
        setEmail()
        setPhone()
        setRefName()
        setRefPhone()
        setAddress()
        setAkpano()
        setProofFile()
        setFile()
        setProofBackFile()
        setProofUrl()
        setProofBackUrl()
        setAvatarUrl()
        setNotes()
        setPortfolios([])
        setErrors({})
        props.addUserClose()(e)
    }

    const handleKeyDown = (event) => {
        // Allow: Backspace, Tab, Delete, Arrow keys
        if (
            ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)
        ) {
            return;
        }
        if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
            return; // do not preventDefault
        }
        // Block non-digit keys
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    };
    const handlePaste = (field)=> { 
        return (e) => {
            e.preventDefault();
            const pasted = e.clipboardData.getData('text');
            const digits = pasted.replace(/\D/g, '');
            const cleaned = digits.slice(-10); // Take last 10 digits
            field === "ref" ? setRefPhone (cleaned) : setPhone(cleaned)
        };
    }
    const validateForm = () => {
        let isError = false;
        const _errors = {};
       
        if (!name) {
            _errors.name = 'Name is required'
            isError = true
        } else {
            delete _errors.name
        }
        if (!email) {
            _errors.email = 'Email is required'
            isError = true
        } else {
            delete _errors.email
        }
        if (!phone) {
            _errors.phone = 'Phone is required'
            isError = true
        } else {
            delete _errors.phone
        }
        if (!file) {
            _errors.file = 'Photo is required'
            isError = true
        } else {
            delete _errors.file
        }
        if (!(proofFile && proofBackFile)) {
            _errors.proof = 'Proof is required'
            isError = true
        } else {
            delete _errors.proof
        }
        setErrors(_errors)
        return !isError
    }

    const doAddUser = async() => {
        //data, file, proof, proofBack
        if(validateForm()) {
            setLoading(true)
            const data = {
                name: name,
                lastName: lastName,
                email: email,
                contactNumber: phone, 
                akpano: akpano,
                address: address,
                refName: refName,
                refPhone: refPhone,
                notes: notes,
                portfolios:portfolios.map(portfolio=>({title: portfolio.title, link: portfolio.link}))
            }
            try {
                await addUser(data, file, proofFile, proofBackFile)
                setLoading(false)                
                props.setUsersChange("User Added Successfully")
                handleAddUserClose()
            } catch (e) {
                if (e.status === 401) {
                    dispatch(removeUserAction())
                    navigate('/');
                }
                console.log(e)
                setLoading(false)
            }
        }
    }
    useEffect(()=>{
        if (props.checkedUser) {
            setPhone(props.checkedUser)
        }
    }, [props.checkedUser])
    

    return (
        <Dialog onClose={handleAddUserClose} fullWidth={true} disableEscapeKeyDown={cropOpen ? true : false}
        maxWidth={"md"} aria-labelledby="customized-dialog-title" open={props.addUserOpen}>
        <DialogTitle id="customized-dialog-title" onClose={handleAddUserClose} sx={{display:'flex', alignItems:'center'}}>
            <Typography> Add User  </Typography>
        </DialogTitle>
        <DialogContent dividers>
            <Stack direction="row" sx={{ width: '100%'}} spacing={2}>
                <Stack direction="column" spacing={2} sx={{ width: '48%'}}>
                    <Stack direction="row" justifyContent="space-between">
                        <TextField
                            error={errors.name}
                            helperText={errors.name}
                            label="First Name"
                            value={name}
                            sx={{width: '48%'}}
                            onChange={(e)=> setName(e.target.value)}
                            variant="outlined"
                        /> 
                        <TextField
                            label="Last Name"
                            sx={{width: '48%'}}
                            value={lastName}
                            onChange={(e)=> setLastName(e.target.value)}
                            variant="outlined"
                        /> 
                    </Stack>
                    
                    <TextField
                        error={errors.email}
                        helperText={errors.email}
                        label="Email"
                        value={email}
                        onChange={(e)=> setEmail(e.target.value)}
                        variant="outlined"
                    />
                    <FormControl>
                        <InputLabel htmlFor="phone">
                            Phone
                        </InputLabel>
                        <OutlinedInput
                            id="phone"
                            value={phone}
                            onKeyDown={handleKeyDown}
                            onPaste={handlePaste("phone")}
                            onChange={(e)=> setPhone(e.target.value)}
                            inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                            startAdornment={
                                <InputAdornment position="start">
                                    +91
                                </InputAdornment>
                            }
                        />
                        {errors.phone && (<FormHelperText id="phone-helper-text" error>{errors.phone}</FormHelperText>)}
                    </FormControl>
                    <TextField
                        label="AKPA No"
                        value={akpano}
                        onChange={(e)=> setAkpano(e.target.value)}
                        variant="outlined"
                    />
                    <Stack direction="row" justifyContent="space-between">
                        <TextField
                            label="Referrer Name"
                            value={refName}
                            onChange={(e)=> setRefName(e.target.value)}
                            variant="outlined"
                            sx={{width: "48%"}}
                        />
                        <FormControl sx={{width: "48%"}}>
                            <InputLabel htmlFor="referrer-phone">
                                Referrer Phone
                            </InputLabel>
                            <OutlinedInput
                                id="referrer-phone"
                                value={refPhone}
                                onKeyDown={handleKeyDown}
                                onPaste={handlePaste("ref")}
                                onChange={(e)=> setRefPhone(e.target.value)}
                                inputProps={{ maxLength: 10, inputMode: 'numeric' }}
                                startAdornment={
                                    <InputAdornment position="start">
                                        +91
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    </Stack>
                    <TextField
                        label="Address"
                        multiline
                        rows={4}
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                    />
                    <TextField
                        label="Notes"
                        multiline
                        rows={4}
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                    />
                </Stack>
                <Stack direction="column" alignItems="center" spacing={2} sx={{ width: '48%'}}>
                    <Stack direction="column" alignItems="center" spacing={2}>
                        <ImageUpload
                            avatarUrl={avatarUrl}
                            setFile={setFile}
                            label="Profile Photo"
                            setAvatarUrl={setAvatarUrl}
                            setCropOpen={setCropOpen}
                            aspectRatio={5/4}
                        />
                        {errors.file && (<Typography color="error">{errors.file}</Typography>)}
                    </Stack>
                    <Stack direction="column" alignItems="center" spacing={2}>
                        <Stack direction="row" spacing={2}>
                            <ImageUpload
                                avatarUrl={proofUrl}
                                label="Proof Front"
                                setFile={setProofFile}
                                setAvatarUrl={setProofUrl}
                                isSquare={true}
                                element="proof-front"
                                type="document"
                                setCropOpen={setCropOpen}
                            />
                            <ImageUpload
                                avatarUrl={proofBackUrl}
                                label="Proof Back"
                                setFile={setProofBackFile}
                                setAvatarUrl={setProofBackUrl}
                                isSquare={true}
                                element="proof-back"
                                type="document"
                                setCropOpen={setCropOpen}
                            />
                        </Stack>
                        {errors.proof && (<Typography color="error">{errors.proof}</Typography>)}
                        <PortfolioSection
                            portfolios={portfolios} 
                            initPortfolio={initPortfolio}
                            deletePortfolio={deletePortfolio}
                            setEditable={setEditable}
                            setPortfolio={setPortfolio}
                        />
                    </Stack>
                </Stack>
            </Stack>        
        </DialogContent>
        <DialogActions>
            <Button disabled={loading} onClick={doAddUser} variant="contained" color="primary">
            Add
            </Button>
            <Button disabled={loading} onClick={handleAddUserClose}  color="primary">
            Cancel
            </Button>
        </DialogActions>
 
      </Dialog>
    )
}


export default AddUser;
